export default __webpack_public_path__ + "media/images/casatb/experience_left-2d37ef0eaee3be3eb5b96b9b94b0d245.png";